const TableRow = ({ children, className = '', innerRef = null, ...props }) => {
  const classes = ['common-table__row', className].filter(Boolean).join(' ');

  return (
    <tr ref={innerRef} className={classes} {...props}>
      {children}
    </tr>
  );
};

export default TableRow;
